// Ámbitos de realización (ver $usesRealizationScopes en main.js): listado propio de cada
// perfil de egreso que se vincula a sus competencias y, desde ellas, a sus asignaturas.

export function scopesOfEgressProfile(realization_scopes, egress_profile_id) {
  return realization_scopes.filter(
    (x) => x.egress_profile == egress_profile_id
  );
}

// Ids de los ámbitos disponibles para una asignatura: los de las competencias que tiene
// seleccionadas (matrix2_competences usa el id de la competencia, no el del vínculo).
export function scopeIdsOfCompetences(matrix2_competences, competence_ids) {
  const ids = new Set();
  matrix2_competences.forEach((competence) => {
    if (competence_ids.includes(competence.id))
      (competence.realization_scopes || []).forEach((id) => ids.add(id));
  });
  return [...ids];
}

// Ámbitos de la asignatura que siguen vigentes: seleccionados y aún vinculados a alguna de
// sus competencias (quitar la competencia oculta el ámbito, igual que con las Capacidades).
export function selectedScopesOfMatter(
  profile_scopes,
  available_ids,
  selected_ids
) {
  return profile_scopes.filter(
    (x) => available_ids.includes(x.id) && selected_ids.includes(x.id)
  );
}

// Orden 1..n según la posición tras arrastrar: solo los ámbitos cuyo orden cambió.
export function reorderedScopes(ordered_scopes) {
  return ordered_scopes
    .map((x, index) => ({ ...x, order: index + 1 }))
    .filter((x, index) => ordered_scopes[index].order != x.order);
}

// Ámbitos vigentes de una asignatura del perfil a partir de los vínculos competencia-perfil
// (EgressProfileCompetence) de ese perfil.
export function scopesOfMatter(
  profile_scopes,
  profile_competences,
  egress_profile_matter
) {
  const competences = profile_competences.map((x) => ({
    id: x.competence,
    realization_scopes: x.realization_scopes,
  }));
  return selectedScopesOfMatter(
    profile_scopes,
    scopeIdsOfCompetences(competences, egress_profile_matter.competences),
    egress_profile_matter.realization_scopes || []
  );
}

// Número con que se muestra cada ámbito en las matrices (id → 1..n): su posición en el
// listado del perfil, que llega ordenado por order. Se usa la posición y no order para
// que no queden saltos cuando se elimina uno.
export function scopeNumbers(profile_scopes) {
  const numbers = {};
  profile_scopes.forEach((x, index) => {
    numbers[x.id] = index + 1;
  });
  return numbers;
}

// Texto del tooltip de un ámbito mostrado por su número
export function scopeTooltip(realization_scope) {
  return realization_scope.description
    ? `${realization_scope.name}: ${realization_scope.description}`
    : realization_scope.name;
}
